import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  permissions: { count: 0, rows: [] },
  loading: false,
};

const requestQuicksightStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchQuicksightSuccess = (state, action) => {
  return updateObject(state, {
    permissions: action.permissions,
    loading: false
  });
};

const requestQuicksightFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteQuicksightSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const updateQuicksightSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postQuicksightSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const SLAAnswer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_QUICKSIGHT_START: return requestQuicksightStart(state, action);
    case actionTypes.FETCH_QUICKSIGHT_SUCCESS: return fetchQuicksightSuccess(state, action);
    case actionTypes.REQUEST_QUICKSIGHT_FAIL: return requestQuicksightFail(state, action);
    case actionTypes.DELETE_QUICKSIGHT_SUCCESS: return deleteQuicksightSuccess(state, action);
    case actionTypes.UPDATE_QUICKSIGHT_SUCCESS: return updateQuicksightSuccess(state, action);
    case actionTypes.POST_QUICKSIGHT_SUCCESS: return postQuicksightSuccess(state, action);

    default: return state;
  }
};

export default SLAAnswer;
